import React from "react";
import _ from 'lodash'
import { FormattedToday, GetDurationInDays } from "../../utilities/DateHelper";
import {Calendar, DaysWaiting, Diagnosis, Note, Payer} from "../../constants/ProIcons"

const ProWaitlistClientDetails = ({data})=>{

    return (
        <div className="p-d-flex p-flex-column">
            <div className="p-mb-2 p-d-flex p-flex-xl-wrap p-jc-between">
                <div className="p-sm-1 p-waitlist-client-detail-field cursor-pointer"> 
                    <Calendar/>
                    <span className="p-waitlist-client-detail-icon-svg">{data.assignmentDate}</span>
                </div>
                {_.get(data, "client") &&<div className="p-lg-2 p-waitlist-client-detail-field cursor-pointer">
                   <Payer/>
                    <span className="p-waitlist-client-detail-icon-svg">{data.payer || ""}</span> 
                </div>}
                {_.get(data, "client") &&<div className="p-lg-6 p-waitlist-client-detail-field cursor-pointer">
                    <Diagnosis/>
                    <span className="p-waitlist-client-detail-icon-svg">{data.clientDiagnoses || ""}</span>
                </div>}                
            </div>  
            <div className="p-d-flex p-mb-4 p-flex-xl-wrap p-jc-between">
                <div className="p-waitlist-client-detail-field cursor-pointer">
                        <Note/>
                        <span className="p-waitlist-client-detail-icon-svg">{data.notes}</span>                  
                </div>  
            </div>
            <div className="p-mb-2">                   
                <hr style={{ color: "red", backgroundColor: "grey", height: 2 }}/>
                <div className="p-mr-2 p-waitlist-client-detail-field cursor-pointer">
                    <DaysWaiting/>
                    <label className="p-waitlist-client-detail-icon-svg">{GetDurationInDays(data.assignmentDate, FormattedToday, 0)}</label> 
                </div>
            </div>               
                   
        </div>
    )

}

export default ProWaitlistClientDetails;